import { breakpoints, colors, radius, borders, shadows, space, zIndex } from '@airwallex/global';
import { navTheme } from './components/nav/index.js';
import { gradientTokens } from './components/gradients/index.js';

// nothing language/character-specific
var baseTheme = {
  breakpoints,
  colors,
  radius,
  borders,
  shadows,
  space,
  zIndex,
  nav: navTheme,
  gradients: gradientTokens
};
export { baseTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIifQ==
